import { useMutation } from '@tanstack/react-query';
import { reportService } from 'shared/src/api';
import { useGoodsSno } from '../../../hooks/useGoodsSno';

export const useReportGoods = () => {
  const goodsSno = useGoodsSno();

  return useMutation({
    mutationFn: (comments: string) => {
      return reportService.postGoodsReport({
        goods_sno: goodsSno,
        comments,
      });
    },
  });
};